module.exports = __webpack_public_path__ + "img/ms-team-2022-23-2.2944e28.jpg";